<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 1100px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/img/产品及服务/基因调控/基因编辑/banner.png" class="img-fluid">-->
<!--      <div class="info">-->

<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>circRNA过表达质粒构建</h1>
      <h2 class="mt10">Construction of circRNA Overexpression Plasmid</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc" style="margin-bottom: 20px;">随着研究的深入，尤其是高通量测序技术普及以后，circRNA的重要性越来越被人们所发现。因其独特的首位相连结构，可以让其更不容易被核酸酶降解，有着比线性RNA分子更长的半衰期。</p>
        <p class="desc">现在主流认为circRNA形成主要有以下三种方式：  </p>
      </div>
      <div class="container">
        <div class="gene_img1  con" style="width: 560px; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA1.jpg" class="img-fluid"></div>
        <div class="gene_img1  cons" style="width: 560px; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA1.jpg" class="img-fluid"></div>
        <p style="text-align: center;margin-top: 30px;">A：侧翼内含子自身互补配对; B：RNA 结合蛋白驱动;  C：mRNA 前体剪接时外显子跳读形成套索。</p>
        <div class="c-title">circRNA过表达质粒构建</div>
        <div class="gene_img con" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA2.jpg"></div>
        <div class="gene_img cons" style="width: -moz-fit-content;width: fit-content; margin-left: auto;margin-right: auto;margin-top: 30px;"><img src="@/assets/img/产品及服务/基因调控/基因干扰/circRNA2_2.jpg"></div>
        <p style="text-align: center;margin-top: 30px;">因circRNA成环机制复杂，成功构建质粒并不能保证其在细胞中一定可以正常成环。擎科按照以下规则分部收费。</p>
      </div>
      <div class="container" style="margin-top: 30px;">
        <table class="table">
          <tr>
            <td style="width: 200px;color:#014492;font-weight:bold;">项目</td>
            <td style="color:#014492;font-weight:bold;">收费（元）</td>
          </tr>
          <tr>
            <td style="width: 200px;">仅构建circRNA质粒</td>
            <td>基因合成费用+2000</td>
          </tr>
          <tr>
            <td style="width: 200px;">如果构建后测序不准确</td>
            <td>仅收取基因合成费用</td>
          </tr>
          <tr>
            <td style="width: 200px;">293T细胞验证过表达效果</td>
            <td>9600</td>
          </tr>
          <tr>
            <td style="width: 200px;">293T细胞验证过表达效果失败</td>
            <td>5000</td>
          </tr>
        </table>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        {name: '基因panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
      ],
      types1: [
        {name: 'sgRNA质粒构建', img: '2', ref: ''},
        {name: 'sgRNA文库构建', img: '3', ref: ''},
        {name: 'CRISPRi/CRISPRa服务', img: '4', ref: ''}
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/circRNA_overexpression.vue